import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profile-category',
  templateUrl: './profile-category.component.html',
  standalone: false
})
export class ProfileCategoryComponent {
  @Input() title: string;
  @Input() activeTab: boolean;
}
